import React from 'react'
import AntdButton from 'antd/lib/button'

import './button.less'

import { mergeClassName } from '../utils'

const Button = (props) => {
  const { className, dark, ...otherProps } = props

  return (
    <React.Fragment>
      <AntdButton
        {...otherProps}
        className={mergeClassName([className, dark ? 'dark-theme' : ''])}
      />
    </React.Fragment>
  )
}

Button.displayName = 'DmpButton'

export default Button
